import React from 'react';
import {withRouter} from 'react-router-dom';

import './section-card.styles.css';

const Card = ({history, match, book}) => (
    <div className='section-card-container-responsive'>
        <div 
            className='section-card-container' 
            onClick = {() => history.push(`${'viewsection/'}${book.id}`)}
        >
            <img   
                className='img-in-container'
                loading='lazy'
                alt='book image'
                src= {process.env.PUBLIC_URL+ book.imglink} 
            />
            <h2> { book.name } </h2>
        </div>
    </div>
    
);
export default withRouter(Card) ;
